import auth0 from 'auth0-js'
import { EventEmitter } from 'events'
import moment from 'moment'
import ParametrosSistemaActions from '../actions/ParametrosSistemaActions'
import store from '../store'
import { isTokenExpired } from './../helpers/JwtHelper'

export default class AuthService extends EventEmitter {
  BACKOFFICE_LOGIN_EXPIRES = null

  constructor () {
    super()

    let AUTH_CLIENT_ID = localStorage.getItem('AUTH_CLIENT_ID')
    let AUTH_DOMAIN = localStorage.getItem('AUTH_DOMAIN')
    let AUTH_CONNECTION_DB_BACKOFFICE = localStorage.getItem('AUTH_CONNECTION_DB_BACKOFFICE')

    this.BACKOFFICE_LOGIN_EXPIRES = localStorage.getItem('BACKOFFICE_LOGIN_EXPIRES')

    if (!AUTH_CLIENT_ID || !AUTH_DOMAIN || !AUTH_CONNECTION_DB_BACKOFFICE || !this.BACKOFFICE_LOGIN_EXPIRES) {
      ParametrosSistemaActions
        .getParametroByLista([
          'AUTH0_CLIENT_ID',
          'AUTH0_DOMAIN',
          'AUTH0_CONNECTION_DB_BACKOFFICE',
          'BACKOFFICE_LOGIN_EXPIRES'
        ])
        .then(params => {
          if (params) {
            AUTH_CLIENT_ID = params
              .find(item => item.cd_parametro === 'AUTH0_CLIENT_ID').valor

            AUTH_DOMAIN = params
              .find(item => item.cd_parametro === 'AUTH0_DOMAIN').valor

            AUTH_CONNECTION_DB_BACKOFFICE = params
              .find(item => item.cd_parametro === 'AUTH0_CONNECTION_DB_BACKOFFICE').valor

            this.BACKOFFICE_LOGIN_EXPIRES = params
              .find(item => item.cd_parametro === 'BACKOFFICE_LOGIN_EXPIRES').valor

            localStorage.setItem('AUTH_CLIENT_ID', AUTH_CLIENT_ID)
            localStorage.setItem('AUTH_DOMAIN', AUTH_DOMAIN)
            localStorage.setItem('AUTH_CONNECTION_DB_BACKOFFICE', AUTH_CONNECTION_DB_BACKOFFICE)
            localStorage.setItem('BACKOFFICE_LOGIN_EXPIRES', this.BACKOFFICE_LOGIN_EXPIRES)

            this.auth0 = new auth0.WebAuth({
              clientID: AUTH_CLIENT_ID,
              domain: AUTH_DOMAIN,
              responseType: 'token id_token'
            })

            this.connectionDB = AUTH_CONNECTION_DB_BACKOFFICE
          }
        })
    } else {
      this.auth0 = new auth0.WebAuth({
        clientID: AUTH_CLIENT_ID,
        domain: AUTH_DOMAIN,
        responseType: 'token id_token'
      })

      this.connectionDB = AUTH_CONNECTION_DB_BACKOFFICE
    }
  }

  login (username, password, callback) {
    this.auth0.login(
      {
        realm: this.connectionDB,
        username,
        password,
        redirectUri: `${window.location.origin}/callback`
      },
      callback
    )
  }

  async signup (email, password, connectionDB, callback) {
    this.auth0.signup(
      {
        realm: connectionDB !== null ? connectionDB : this.connectionDB,
        connection: connectionDB !== null ? connectionDB : this.connectionDB,
        grant_type: 'password',
        email,
        password
      },
      callback
    )
  }

  parseHash (hash) {
    if (hash) {
      this.auth0.parseHash({ hash }, (error, authResult) => {
        if (!authResult) {
          window.location = '/'
        }

        if (
          !error &&
          authResult &&
          authResult.accessToken &&
          authResult.idToken
        ) {
          this.setToken(authResult.accessToken, authResult.idToken)
          window.location = '/'

          this.auth0.client.userInfo(
            authResult.accessToken,
            (error2, profile) => {
              if (error2) {
                console.log('Error loading the Profile', error2)
              } else {
                this.setProfile(profile)
              }
            }
          )
        } else if (authResult && authResult.error) {
          alert('Error: ' + authResult.error)
        }
      })
    } else {
      window.location = '/'
    }
  }

  loggedIn () {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken()
    return !!token && !isTokenExpired(token)
  }

  setToken (accessToken, idToken) {
    // Saves user access token and ID token into local storage
    localStorage.setItem('access_token', accessToken)
    localStorage.setItem('jwt', idToken)
    localStorage.setItem('expires_login', moment().add(this.BACKOFFICE_LOGIN_EXPIRES || 60, 'minutes').toISOString())

    store.commit('setAuthenticated', true)

    this.getUserInfo(accessToken)
  }

  setProfile (profile) {
    // Saves profile data to localStorage
    localStorage.setItem('profile', JSON.stringify(profile))
    // Triggers profile_updated event to update the UI
    this.emit('profile_updated', profile)
  }

  getProfile () {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem('profile')
    return profile ? JSON.parse(localStorage.profile) : {}
  }

  getToken () {
    // Retrieves the user token from localStorage
    return localStorage.getItem('jwt')
  }

  getUserInfo (accessToken) {
    this.auth0.client.userInfo(accessToken, (error, profile) => {
      if (error) {
        console.log('Error loading the Profile', error)
      } else {
        this.setProfile(profile)
      }
    })
  }

  logout () {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('id_token')
    localStorage.removeItem('profile')
  }
}



// WEBPACK FOOTER //
// ./src/auth/AuthService.js